import type { Infer } from 'superstruct';
import {
	array,
	assign,
	boolean,
	integer,
	nullable,
	object,
	optional,
	pick,
	string,
	trimmed,
} from 'superstruct';

import { EditPermissionsDto } from '@adflow/shared/util-data';
import type { UserActor } from '@adflow/shared/util-permissions';
import { ViewRoleListedDto } from '@adflow/shared/util-roles';
import { stringDate } from '@adflow/shared/util-superstruct';

export const ViewUserDto = object({
	id: integer(),
	name: trimmed(string()),
	email: string(),
	superuser: boolean(),
	lastLoggedInAt: nullable(stringDate()),
	createdAt: stringDate(),
	archived: boolean(),
	isLocked: optional(boolean()),
});

export const ViewUserListedDto = assign(
	ViewUserDto,
	object({
		roles: array(ViewRoleListedDto),
	})
);

/**
 * Use this dto when loading user information on another entity
 * e.g. customer's agents or quote's createdBy
 */
export const ViewUserInfoDto = pick(ViewUserDto, [
	'id',
	'name',
	'email',
	'superuser',
	'lastLoggedInAt',
	'archived',
]);

export const ViewAuthUserDto = assign(
	pick(ViewUserDto, [
		'id',
		'name',
		'email',
		'superuser',
		'lastLoggedInAt',
		'archived',
		'createdAt',
	]),
	object({
		permissions: EditPermissionsDto,
	})
);

export type ViewUserDto = Infer<typeof ViewUserDto>;
export type ViewUserListedDto = Infer<typeof ViewUserListedDto>;
export type ViewUserInfoDto = Infer<typeof ViewUserInfoDto>;
export type ViewAuthUserDto = Infer<typeof ViewAuthUserDto>;

export function authUserToActor(user: ViewAuthUserDto): UserActor {
	return {
		type: 'User',
		userId: user.id,
		userName: user.name,
	};
}
